// Events from application.js were moved to this file as part of reorganization process.
// All of them should be moved to anouther place. Don't add new events to this file!
import $ from 'jquery'
import { addAlertViewEvent } from 'application/ga_alert_view_event'
import { trim } from 'lodash'
import { getSessionDuration } from 'application/session_duration'

$(document).ready(function() {
  var $censorForm,
      $referralBanner,
      $rejoinMembershipBanner,
      $marketingBanner,
      $marketingSPBanner,
      $springCampaignBanner;

  function init() {
    $censorForm = $('.censor form.button_to');
    $referralBanner  = $('.referral-banner');
    $rejoinMembershipBanner  = $('.rejoin-membership-banner');
    $marketingBanner = $('.purple-alert-banner');
    $marketingSPBanner = $('.purple-alert-sp-banner');
    $springCampaignBanner  = $('.spring-campaign-banner');

    $('.w-flexible-header').wFlexibleHeader();
    $('.flexible__breadcrumbs-container').breadcrumbsFlexible();

    if ($referralBanner.length) {
      gaSendReferralAlertViewEvent()
    }

    if ($rejoinMembershipBanner.length) {
      gaSendRejoinMembershipAlertViewEvent($rejoinMembershipBanner)
    }

    if ($springCampaignBanner.length) {
      gaSendSpringCampaignAlertViewEvent()
    }

    if ($marketingBanner.length) {
      gaSendMarketingAlertViewEvent($marketingBanner)
    }

    if ($marketingSPBanner.length) {
      gaSendSPMarketingAlertViewEvent($marketingSPBanner)
    }

    // stubbing out console log for non-Firebug enabled browsers
    if (!window.console) {
      window.console = { log: function() { return true; } };
    }

    // Show Flash Message popup if needed
    showFlashPopup();

    bindDomEvents();
    bindCensorButton();
  }

  // Bind DOM events
  function bindDomEvents() {
    // Close Overlays on Unload
    $(window).on('unload', function() {
      SOPHIA.closeOverlayBox();
    });
  }

  function bindCensorButton() {
     $censorForm.on('submit', function() {
      $('input[type=submit], button[type=submit]', $(this)).addClass("disabled").prop('disabled', true);
    });
  }

  function gaSendReferralAlertViewEvent() {
    const ga_alert_view_data = {
      alert_name: 'refer a friend',
      alert_id: '',
      event_detail: 'refer a friend banner'
    }

    addAlertViewEvent(ga_alert_view_data)
  }

  function gaSendRejoinMembershipAlertViewEvent(banner) {
    const text = banner.text()

    const ga_alert_view_data = {
      session_duration: getSessionDuration(),
      alert_name: 'rejoin membership banner',
      alert_id: '',
      event_detail: trim(text.slice(0, 24))
    }

    addAlertViewEvent(ga_alert_view_data)
  }

  function gaSendMarketingAlertViewEvent(banner) {
    const text = banner.text()
    const ga_alert_view_data = {
      alert_name: 'partner marketing banner',
      alert_id: '',
      event_detail: trim(text.slice(0, 20))
    }

    addAlertViewEvent(ga_alert_view_data)
  }

  function gaSendSPMarketingAlertViewEvent(banner) {
    const text = banner.text()
    const ga_alert_view_data = {
      alert_name: 'sp banner',
      alert_id: '',
      event_detail: trim(text.slice(0, 20))
    }

    addAlertViewEvent(ga_alert_view_data)
  }

  function gaSendSpringCampaignAlertViewEvent() {
    const ga_alert_view_data = {
      alert_name: 'spring_into_sophia_learning_with_$20_savings',
      alert_id: '',
      event_detail: 'spring into sophia banner'
    }

    addAlertViewEvent(ga_alert_view_data)
  }

  // Shows Flash Popup if needed
  function showFlashPopup() {
    var $flashMessageBlock = $('.flash');

    if ( $flashMessageBlock.length > 0 ) {
      var type = '';

      if ( $flashMessageBlock.hasClass('flash_error') )   type = 'error';
      if ( $flashMessageBlock.hasClass('flash_warning') ) type = 'notice';
      if ( $flashMessageBlock.hasClass('flash_notice') )  type = 'success';

      SOPHIA.flashMessage( $('.flash').html(), type );
      $('.flash').remove();
    }
  }

  init();
});
